const { __ } = wp.i18n;
const { PluginDocumentSettingPanel } = wp.editPost;
const { withSelect, select } = wp.data;
const { Button, Notice } = wp.components;
const { compose } = wp.compose;
const I18N_DOMAIN = 'ib-infobeans';
const { MediaUpload, MediaUploadCheck } = wp.blockEditor;
const ALLOWED_MEDIA_TYPES = ['video'];
const { useState } = wp.element;

const VideoPlayer = ({ meta }) => {
	const [videoName, setVideoName] = useState(meta?.video_title ? meta?.video_title : '');

	const updateMeta = metaKey => value => {
		wp.data.dispatch('core/editor').editPost({
			meta: {
				...meta,
				[metaKey]: value,
			},
		});
	};

	const onSelect = video => {
		setVideoName(video?.title);
		updateMeta('video_title')(video?.title);
		wp.data.dispatch('core/editor').editPost({ meta: { video_trailer: video?.url.toString() } });
	};

	const deleteVideo = () => {
		setVideoName('');
		updateMeta('video_title')('');
		wp.data.dispatch('core/editor').editPost({ meta: { video_trailer: '' } });
	};

	return (
		<PluginDocumentSettingPanel
			name="video-trailer"
			title={__('Video Trailer', I18N_DOMAIN)}
			className="video_trailer"
		>
			<>
				{
					<div>
						<div>
							<MediaUploadCheck>
								<MediaUpload
									allowedTypes={ALLOWED_MEDIA_TYPES}
									onSelect={onSelect}
									isTertiary
									render={({ open }) => (
										<Button isPrimary onClick={open}>
											{__('Upload', 'idg-video-episode')}
										</Button>
									)}
									displayUpload
								/>
							</MediaUploadCheck>

							{videoName !== '' && (
								<>
									<Notice status="success" isDismissible="false">
										{videoName}
									</Notice>

									<Button isDestructive onClick={deleteVideo}>
										{__('Delete', 'idg-video-episode')}
									</Button>
								</>
							)}
						</div>
					</div>
				}
			</>
		</PluginDocumentSettingPanel>
	);
};

export default compose(
	withSelect(() => {
		const meta = select('core/editor').getEditedPostAttribute('meta');
		return {
			meta,
		};
	}),
)(VideoPlayer);
